import React, { useCallback, useState } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { SprintPackages } from './components/SprintPackages';
import { PartnerSection } from './components/PartnerSection';
import { BlogPreview } from './components/BlogPreview';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { BlogPostPage } from './components/BlogPostPage';
import { BlogListPage } from './components/BlogListPage';
import { ImpressumPage } from './components/ImpressumPage';
import { DatenschutzPage } from './components/DatenschutzPage';
import { blogPosts } from './data/blogPosts';
type Route = {
  page: 'home';
} | {
  page: 'blog-list';
} | {
  page: 'blog-post';
  slug: string;
} | {
  page: 'imprint';
} | {
  page: 'privacy';
};
export function App() {
  const [route, setRoute] = useState<Route>({
    page: 'home'
  });
  const goHome = useCallback(() => setRoute({
    page: 'home'
  }), []);
  const goToBlogList = useCallback(() => setRoute({
    page: 'blog-list'
  }), []);
  const goToPost = useCallback((slug: string) => setRoute({
    page: 'blog-post',
    slug
  }), []);
  const goToImprint = useCallback(() => setRoute({
    page: 'imprint'
  }), []);
  const goToPrivacy = useCallback(() => setRoute({
    page: 'privacy'
  }), []);
  if (route.page === 'privacy') {
    return <div className="min-h-screen bg-[#020611] text-[#F5F5F0] selection:bg-accent selection:text-[#020611]" data-id="element-0">
        <Navbar onNavigateHome={goHome} data-id="element-1" />
        <DatenschutzPage onBack={goHome} data-id="element-2" />
        <Footer onNavigateImprint={goToImprint} onNavigatePrivacy={goToPrivacy} data-id="element-3" />
      </div>;
  }
  if (route.page === 'imprint') {
    return <div className="min-h-screen bg-[#020611] text-[#F5F5F0] selection:bg-accent selection:text-[#020611]" data-id="element-4">
        <Navbar onNavigateHome={goHome} data-id="element-5" />
        <ImpressumPage onBack={goHome} data-id="element-6" />
        <Footer onNavigateImprint={goToImprint} onNavigatePrivacy={goToPrivacy} data-id="element-7" />
      </div>;
  }
  if (route.page === 'blog-post') {
    const post = blogPosts.find(p => p.slug === route.slug);
    if (post) {
      return <div className="min-h-screen bg-[#020611] text-[#F5F5F0] selection:bg-accent selection:text-[#020611]" data-id="element-8">
          <Navbar onNavigateHome={goHome} data-id="element-9" />
          <BlogPostPage post={post} onBack={goToBlogList} data-id="element-10" />
          <Footer onNavigateImprint={goToImprint} onNavigatePrivacy={goToPrivacy} data-id="element-11" />
        </div>;
    }
  }
  if (route.page === 'blog-list') {
    return <div className="min-h-screen bg-[#020611] text-[#F5F5F0] selection:bg-accent selection:text-[#020611]" data-id="element-12">
        <Navbar onNavigateHome={goHome} data-id="element-13" />
        <BlogListPage onBack={goHome} onSelectPost={goToPost} data-id="element-14" />
        <Footer onNavigateImprint={goToImprint} onNavigatePrivacy={goToPrivacy} data-id="element-15" />
      </div>;
  }
  return <div className="min-h-screen bg-[#020611] text-[#F5F5F0] selection:bg-accent selection:text-[#020611]" data-id="element-16">
      <Navbar onNavigateHome={goHome} data-id="element-17" />
      <main data-id="element-18">
        <HeroSection data-id="element-19" />
        <ProblemSection data-id="element-20" />
        <SolutionSection data-id="element-21" />
        <SprintPackages data-id="element-22" />
        <PartnerSection data-id="element-23" />
        <BlogPreview onViewAll={goToBlogList} onSelectPost={goToPost} data-id="element-24" />
        <FAQSection data-id="element-25" />
        <CTASection data-id="element-26" />
      </main>
      <Footer onNavigateImprint={goToImprint} onNavigatePrivacy={goToPrivacy} data-id="element-27" />
    </div>;
}